var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 119,
    viewBox: "0 0 183 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 81,
    width: 183,
    height: 38,
    rx: 8,
    fill: "#00E309",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.751 61.2513C131.251 78.7513 118.056 95.2293 99.5411 98.9113C90.511 100.71 81.1438 99.6132 72.7731 95.778C64.4025 91.9429 57.4551 85.5646 52.9203 77.5514C48.3856 69.5382 46.4945 60.2985 47.5165 51.148C48.5384 41.9975 52.4212 33.4027 58.6121 26.5873C71.3101 12.6013 92.7511 8.7513 110.251 15.7513",
    stroke: "#00B913",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 54.25L92.75 71.75L134.75 26.25",
    stroke: "#00B913",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.080622b593cb84ba74a813b4102ec371.svg";
export { ForwardRef as ReactComponent };